import * as yup from 'yup'

export const inspect = yup.object().shape({
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  codigoInspeccion: yup.string().required('El código es obligatorio'),
  tipoInspeccion: yup.string().required('El tipo de inspección es obligatorio'),
  fechaProgramacion: yup.string().required('La fecha programada es obligatorio'),
  cumpleEstandar: yup.string().required('El estándar es obligatorio'),
  alcanceInspeccion: yup.string().required('El alcance es obligatorio'),
  tipoAdministracion: yup.string().required('El tipo de administración es obligatorio'),
  puntoId: yup
    .string()
    .nullable()
    .when('tipoAdministracion', {
      is: (valorCampoTipoAdministracion) => valorCampoTipoAdministracion === 'COMPAÑÍA',
      then: yup.string().nullable().required('El punto es obligatorio'),
      otherwise: yup.string().nullable(),
    }),
  proveedorId: yup
    .string()
    .nullable()
    .when('tipoAdministracion', {
      is: (valorCampoTipoAdministracion) => valorCampoTipoAdministracion === 'EXTERNO',
      then: yup.string().nullable().required('El proveedor es obligatorio'),
      otherwise: yup.string().nullable(),
    }),
})
